export enum TagTypesEnum {
  SYSTEMS = 'SYSTEMS',
  SOLUTIONS = 'SOLUTIONS',
  CATEGORIES = 'CATEGORIES',
  SCOPES = 'SCOPES',
  TENANTS = 'TENANTS',
  USERS = 'USERS',
  SUBSCRIPTIONS = 'SUBSCRIPTIONS',
  INVOICES = 'INVOICES',
  FLOWS = 'FLOWS',
  CONTACTS = 'CONTACTS',
  PARTNERS = 'PARTNERS',
  SUB_SUBSCRIPTIONS = 'SUB_SUBSCRIPTIONS',
  SUBSCRIPTIONS_LOCATIONS = 'SUBSCRIPTIONS_LOCATIONS',
}
